<div class="d-flex align-items-center password-strength mb-2" *ngIf="strength">
  <span class="me-2 password-stength-text" *ngIf="msg">
    {{ msg | translate }}
  </span>
  <span class="visually-hidden" *ngIf="msg !== 'Strong'">
    {{ 'AUTH.PASSWORD_STRENGTH.NOT_STRONG_WARNING' | translate }}
  </span>
  <pmd-progressbar [value]="strength" [type]="type" [style.height]="'8px'"> </pmd-progressbar>
</div>
